<template>
  <div class="jps-curation-iframe" :class="def.layout">
    <ClientOnly>
      <JIframe :src="def.iframeSrc" />
    </ClientOnly>
    <div class="jci-description">
      <div v-if="!isEmpty(def.caption)" class="jci-caption">
        {{ ls(def.caption) }}
      </div>
      <div v-if="!isEmpty(def.description)" class="jci-description-text">
        {{ ls(def.description) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  def: PartIframe
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/components/_curation-iframe';
</style>
